import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { COUPLE } from "@/data/wedding";

const links = [
  { label: "Invitation", id: "invitation" },
  { label: "Reception", id: "reception" },
  { label: "RSVP", id: "rsvp" },
];

export const Nav = ({ onNavigate }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6 }}
      className={`fixed inset-x-0 top-0 z-[65] transition-colors duration-500 ${
        scrolled
          ? "border-b border-gold/30 bg-kasavu/85 backdrop-blur-xl"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 md:px-10">
        <button
          onClick={() => onNavigate("top")}
          className="font-script text-2xl leading-none text-[var(--maroon)] md:text-3xl"
        >
          {COUPLE.bride.name.charAt(0)}<span className="text-[var(--gold)]"> &amp; </span>{COUPLE.groom.name.charAt(0)}
        </button>

        <div className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => onNavigate(l.id)}
              className="group relative font-body text-xs uppercase tracking-[0.22em] text-[var(--ink)]"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[var(--gold)] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>

        <button
          data-testid="nav-rsvp-link"
          onClick={() => onNavigate("rsvp")}
          className="rounded-full bg-[var(--maroon)] px-5 py-2 font-body text-[11px] uppercase tracking-[0.2em] text-[var(--kasavu)] transition-transform duration-300 hover:scale-105"
        >
          Accept Invite
        </button>
      </nav>
      <div className="kasavu-border" style={{ height: 6 }} />
    </motion.header>
  );
};
